import { bindActionCreators } from 'redux'

import SelectPlan from '@piconetworks/select-plan'
import withInjection from '@piconetworks/with-injection'

import Internal from 'common/modules/internal'
import Loader from 'common/modules/loader'
import Plan from 'common/modules/plan'

import Wizard from 'common/pkgs/WizardRedux'
import { Link } from '@piconetworks/router-adapter'

const isFetching = (state) => state.plan.isFetching

const discountCodeSuccess = (state) => state.plan.discountCodeSuccess

const altPlans = {
    monetizationIsPledge: (plan) => !!plan?.pledge_mode,
    monetizationTypeIsPass: (plan) => plan?.tiers?.[0]?.options?.[0]?.type === 'pass',
}

const getAlternativePlanType = ({
    isUsingDiscountCode,
    isGiftWizard,
    isSwitchingPlans,
}) => {
    if (isUsingDiscountCode) return 'discount'
    if (isGiftWizard) return 'gift'
    if (isSwitchingPlans) return 'switching'

    return ''
}

const tierOrderSort = (a, b) => ((a.tierOrder > b.tierOrder) ? 1 : -1)

const mapStateToProps = (state, props) => {
    const wizardName = props?.router?.query?.id
    const isGiftWizard = wizardName.startsWith('GiftWizard')
    const isSwitchingPlans = Loader.selectors.currentPurchaseActive(state) && !isGiftWizard
    const isUsingDiscountCode = state?.plan?.verifiedDiscountCode
    const useAlternativePlans = state?.plan?.alternativePlans
        && (isUsingDiscountCode || isGiftWizard || isSwitchingPlans)

    const alternativePlanType = getAlternativePlanType({
        isUsingDiscountCode,
        isGiftWizard,
        isSwitchingPlans,
    })

    const monetizationIsPledge = useAlternativePlans
        ? altPlans.monetizationIsPledge(state?.plan?.alternativePlans[alternativePlanType])
        : Loader.selectors.monetizationIsPledge(state)

    const monetizationTypeIsPass = useAlternativePlans
        ? altPlans.monetizationTypeIsPass(state?.plan?.alternativePlans[alternativePlanType])
        : Loader.selectors.monetizationTypeIsPass(state)

    return {
        ...props,
        currentPlanTierIdSelected: Loader.selectors.currentPlanTierId(state),
        isGiftWizard,
        isSwitchingPlans,
        isUsingDiscountCode,
        getTiersSorted: (scope) => {
            if (isUsingDiscountCode) {
                return [
                    ...(state?.plan?.alternativePlans?.discount?.tiers || []),
                ].sort(tierOrderSort)
            }

            if (isGiftWizard) {
                return [
                    ...(state?.plan?.alternativePlans?.gift?.tiers || []),
                ].sort(tierOrderSort)
            }

            if (isSwitchingPlans) {
                return [
                    ...(state?.plan?.alternativePlans?.switching?.tiers || []),
                ].sort(tierOrderSort)
            }

            return Loader.selectors.tiersSorted(state, scope)
        },
        getPlanTexts: (scope) => Loader.selectors.planTexts(state, scope),
        groupName: Loader.selectors.groupName(state),
        featureList: (scope) => Loader.selectors.featureList(state, scope),
        linkColor: Loader.selectors.linkColor(state),
        loader: Loader.selectors.loader(state),
        monetizationBillingStatus: Loader.selectors.monetizationBillingStatus(state),
        monetizationIsPledge,
        monetizationTypeIsPass,
        plan: state.plan,
        publisherName: Loader.selectors.publisherName(state),
        userHasCurrentPurchases: Loader.selectors.userHasCurrentPurchases(state),
        userLoader: state.loader.user,
        guestLoader: state.loader.guest,
        publisherUrl: Loader.selectors.publisherUrl(state),
        publisherId: Loader.selectors.publisherId(state),
        isFetching: isFetching(state),
        discountCodeSuccess: discountCodeSuccess(state),
        updateLoaderPricingMonetizationTiers: (args) => Internal.creators.sendMessage({
            payload: {
                target: 'pico_arbiter',
                ...Loader.creators.updateLoaderPricingMonetizationTiers(args),
            },
        }),
        UPDATE_LOADER: Loader.types.UPDATE_LOADER,
        Wizard,
        Link,
        last4: (
            !state.payment.isDefaultBeingSet
            && Loader.selectors.badgePaymentMethod(state)?.last4
        ),
        cardType: (
            !state.payment.isDefaultBeingSet
            && Loader.selectors.badgePaymentMethod(state)?.cardType
        ),
        paymentBadgeLink: wizardName && {
            href: {
                pathname: '/cards',
                query: {
                    ...(wizardName && { id: wizardName }),
                },
            },
            as: {
                pathname: '/cards',
                query: {
                    ...(wizardName && { id: wizardName }),
                },
            },
        },
        isGift: Loader.selectors.currentSubscriptionId(state) === 'GIFT',
        currentPurchaseActive: Loader.selectors.currentPurchaseActive(state),
    }
}

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({
        resetPlan: Plan.creators.reset,
        verifyDiscountCode: Plan.creators.verifyDiscountCode,
    }, dispatch),
    getLoader: (payload) => {
        dispatch(
            Plan.creators.getPlans(payload),
        )
    },
})

const InjectedSelectPlan = withInjection(SelectPlan, {
    mapStateToProps,
    mapDispatchToProps,
})

export default InjectedSelectPlan
